<div id="tabs" [class.disabled]="isDisabled">
  <div id="line">
    <div
      id="line-active-{{ this.randomID }}"
      class="line-active"
      [style.transform]="transformX"
      [class.disabled]="isDisabled"
    ></div>
  </div>

  <div
    [id]="i + '-' + this.randomID"
    class="tab"
    matRipple
    (click)="selectTab(i)"
    *ngFor="let tab of this.config.tabs; let i = index"
    [tabindex]="i"
    [class.disabled]="isDisabled"
  >
    <div class="tab-wrapper">
      <qr-icon
        *ngIf="tab.icon"
        class="icon"
        [name]="tab.icon"
        [color]="getIconColor(i)"
      ></qr-icon>
      <p
        class="subheading-01-semi-bold"
        [ngClass]="{ active: idTabActive == i }"
      >
        {{ tab.text }}
      </p>
    </div>
    <qr-icon
      class="error"
      [name]="ICON_ERROR"
      [color]="ICON_COLOR_ERROR_900"
      *ngIf="tab.hasError"
    ></qr-icon>
  </div>
</div>
